import store from '..'
import axios from 'axios'
import API from '@/common/api'

export default {
  namespaced: true,
  state: {
    hotelGeo: {},
    list: [],
    listView: {},
    type: [],
    filter: {
      word: '',
      type: ''
    },
    display: [],
    recommend: []
  },
  mutations: {
    listView (state, data) {
      state.listView = data
    },
    initDisplay (state) {
      state.display = []
      state.recommend = []
    },
    initFilter (state) {
      state.filter.word = ''
      state.filter.type = ''
    },
    setFilter: function (state, data) {
      Object.keys(data).forEach(function (x) {
        state.filter[x] = data[x]
      })
    },
    setDisplay: function (state, data) {
      const hasPlaceId = state.display.find(x => x.placeId === data.placeId)
      if (hasPlaceId) {
        state.display = state.display.filter(x => x.placeId !== data.placeId)
      } else {
        state.display.push(data)
      }
      state.list.find(x => x.placeId === data.placeId).visible = data.value
    },
    setRecommend: function (state, data) {
      const hasPlaceId = state.recommend.find(x => x.placeId === data.placeId)
      if (hasPlaceId) {
        state.recommend = state.recommend.filter(x => x.placeId !== data.placeId)
      } else {
        state.recommend.push(data)
      }
      state.list.find(x => x.placeId === data.placeId).recommend = data.value
    }
  },
  actions: {
    async getSiteGeo ({ state }) {
      const site = store.state.authentication.userInfo.siteid
      try {
        const res = await axios.get(`${API.BASE_URL}/castit/file?cmd=get-site-geo&siteid=${site}`)
        const hotelGeo = res.data.message
        state.hotelGeo = {
          lat: Number(hotelGeo.lat),
          lng: Number(hotelGeo.lon)
        }
        return res.data.message
      } catch (ex) {
        console.log(ex.response.data)
        return ex.response.data
      }
    },
    async getLocalInfoType ({ state, commit }) {
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/file`, {
          ...API.GET_LOCAL_INFO_CATEGORY,
          id: store.state.authentication.requestId
        })
        state.type = res.data.message
        return res.data.message
      } catch (ex) {
        return false
      }
    },
    async getLocalList ({ state }) {
      const site = store.state.authentication.userInfo.siteid
      try {
        const res = await axios.get(`${API.BASE_URL}/castit/file?cmd=get-local-info&siteid=${site}&edit=true&type=all`)
        state.list = res.data.message.length ? res.data.message : []
        return res.data.message
      } catch (ex) {
        return ex.response.data
      }
    },
    setVisible ({ state }) {
      if (state.display.length > 0) {
        return axios.post(`${API.BASE_URL}/castit/file`, {
          ...API.UPDATE_LOCAL_INFO_VISIBLE,
          id: store.state.authentication.requestId,
          data: state.display
        }).then((res) => {
          return res
        }).catch((ex) => {
          // console.error('error:', ex)
          return false
        })
      } else {
        return true
      }
    },
    setRecommend ({ state }) {
      if (state.recommend.length > 0) {
        return axios.post(`${API.BASE_URL}/castit/file`, {
          ...API.UPDATE_LOCAL_INFO_RECOMMEND,
          id: store.state.authentication.requestId,
          data: state.recommend
        }).then((res) => {
          return res
        }).catch((ex) => {
          // console.error('error:', ex)
          return false
        })
      } else {
        return true
      }
    },
    updateLocalinfo ({ state, dispatch }) {
      return dispatch('setVisible').then(() => {
        dispatch('setRecommend')
      })
    },
    async createPlaceid ({ state }, placeid) {
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/file`, {
          ...API.CREATE_PLACEID,
          id: store.state.authentication.requestId,
          placeId: placeid
        })
        return res.data
      } catch (ex) {
        return ex.response.data
      }
    }
  },
  getters: {
    getList (state) {
      return state.list
    },
    getType (state) {
      const realtype = state.list.map(x => x.siteType)
      const types = state.type.filter(x => realtype.includes(x))
      const recommend = state.list.filter(x => x.recommend).length > 0 ? ['recommend'] : []
      return recommend.concat(types)
    },
    getFilter (state) {
      return state.filter
    },
    getDisplay (state) {
      return state.display
    },
    getRecommend (state) {
      return state.recommend
    }
  }
}
